import React, { Component } from "react"
import { Row, Col, Select, Text } from "../";
import i18n from "../../../../Utils/i18next";
import { getPopupContainer } from "../../../../Utils/Global";

/**
 * Select component for conditional formatting icon align
 */
export default class Selecting extends Component {
    handleChange = (value) => {
        this.props.handleChange({
            type: this.props.type,
            value: value
        });
    }

    render() {
        return (
            <Row style={{ marginBottom: "5px" }}>
                <Col style={{ textAlign: "center" }} span={3}>
                    {this.props.icon && <this.props.icon style={{ fontSize: "16px" }} />}
                </Col>
                <Col style={{ textAlign: "left" }} span={9}>
                    <Text
                        style={{
                            fontSize: "16px",
                            display: "inline-block",
                            marginTop: "2px",
                        }}
                    >
                        {this.props.title}
                    </Text>
                </Col>
                <Col span={12}>
                    <Select
                        onChange={this.handleChange}
                        type={this.props.type}
                        style={{ width: "100%" }}
                        disabled={this.props.disabled}
                        value={this.props.value ? this.props.value : this.props.option.defaultValue}
                        getPopupContainer={getPopupContainer}
                    >
                        {this.props.option.values.map((value) => (
                            <Select.Option value={value} key={value}>{i18n.t(`Dashboard.ConditionalFormatting.${value}`)}</Select.Option>
                        ))}
                    </Select>
                </Col>
            </Row>
        )
    }
}